/*
 * @Author: wjw this.wujiwen@gmail.com
 * @Date: 2022-11-03 11:42:01
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-06-25 18:24:48
 * @FilePath: \manage_property\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createApp } from 'vue';
// import '@/core/prototype.js';

//pinia状态管理
import { createPinia } from 'pinia';

// 引入数据持久化插件
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

//elemet-ui
import ElementPlus from 'element-plus';
import { ElMessage } from 'element-plus';

// import 'element-plus/dist/index.css';
import locale from 'element-plus/es/locale/lang/zh-cn';

//图片预览
import vue3PreviewImage from 'vue3-preview-image';

//element icon
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

// echarts
import * as echarts from 'echarts';

import '@/assets/css/index.scss';
//路由
import router from './core/router.js';
import './permission'; // permission control

import { permission } from '@/utils/permission';

import App from './App.vue';

//注册自定义全局组件
import GlobalComponents from '@/components/globalComponents.js';

const app = createApp(App);
// 注册
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(router);
app.use(pinia);
app.use(vue3PreviewImage);
app.use(ElementPlus, { locale: locale });
app.provide('message', ElMessage);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.config.globalProperties.$echarts = echarts;
app.config.globalProperties.$permission = permission;

GlobalComponents(app);

app.mount('#app');
